document.addEventListener('DOMContentLoaded', function () {
  var resizeTimer;

  function initCustomFeaturedSlider() {
    if (typeof window.jQuery === 'undefined' || typeof window.jQuery.fn.slick === 'undefined') {
      return;
    }

    var $ = window.jQuery;

    $('.custom-featured-slider').each(function () {
      var $section = $(this);
      var $slider = $section.find('.custom-featured-slider__track');
      var $progressBar = $section.find('.custom-featured-slider__progress span');
      var $prevArrow = $section.find('.custom-featured-prev');
      var $nextArrow = $section.find('.custom-featured-next');

      if (!$slider.length || $slider.hasClass('slick-initialized')) return;

      var slidesMobile = parseInt($slider.attr('data-slides-mobile'), 10) || 1;
      var slidesTablet = parseInt($slider.attr('data-slides-tablet'), 10) || 2;
      var slidesDesktop = parseInt($slider.attr('data-slides-desktop'), 10) || 3;

      function updateProgress(event, slick, currentSlide) {
        var current = (currentSlide || 0) + 1;
        var totalSteps = slick.slideCount - slick.options.slidesToShow + 1;

        if (totalSteps < 1) totalSteps = 1;

        var progress = (current / totalSteps) * 100;

        if (progress > 100) progress = 100;

        $progressBar.css('width', progress + '%');
      }

      $slider.on('init reInit afterChange', updateProgress);

      $slider.slick({
        slidesToShow: slidesDesktop,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        speed: 350,
        prevArrow: $prevArrow,
        nextArrow: $nextArrow,
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: slidesTablet
            }
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: slidesMobile
            }
          }
        ]
      });
    });
  }

  initCustomFeaturedSlider();

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initCustomFeaturedSlider, 250);
  });

  document.addEventListener('shopify:section:load', function () {
    initCustomFeaturedSlider();
  });
});